import { dateTimeFormatter } from "services";
import { PropertyDateType } from "../hooks/usePDAuctionDetails";

type DateDisplayVariant = "long" | "short";

interface AuctionStartDateTimeTypes {
  propertyDateType?: PropertyDateType;
  dateTimeString?: string;
  isAuctionConducted?: boolean;
  isEmdDateOnly?: boolean;
  isAuctionStartDateOnly?: boolean;
  isAuctionEndDateOnly?: boolean;
  variant?: DateDisplayVariant;
  showIST?: boolean;
}

export const getAuctionDateTimes = ({
  propertyDateType,
  dateTimeString,
  isAuctionConducted,
  isEmdDateOnly,
  isAuctionStartDateOnly,
  isAuctionEndDateOnly,
  variant = "long",
  showIST = true,
}: AuctionStartDateTimeTypes) => {
  if (!propertyDateType) return "N/A";

  switch (propertyDateType) {
    case "undated":
      return "Coming Soon";

    case "private_treaty":
      return "Private Treaty";

    case "dated":
      if (!dateTimeString) return "N/A";

      const isDateOnly =
        isEmdDateOnly || isAuctionStartDateOnly || isAuctionEndDateOnly;

      // Conducted auction → always datetime
      if (isAuctionConducted) {
        return dateTimeFormatter({
          date: dateTimeString,
          mode: "datetime",
          variant,
          showIST,
        });
      }

      // Date-only scenarios
      if (isDateOnly) {
        return dateTimeFormatter({
          date: dateTimeString,
          mode: "date",
          variant,
        });
      }

      // Default upcoming auction
      return dateTimeFormatter({
        date: dateTimeString,
        mode: "datetime",
        variant,
        showIST,
      });

    default:
      return "N/A";
  }
};
